import { Grid } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import React, { useContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { SubmissionError } from 'redux-form'
import Button from '../../../../components/Button'
import FormButton from '../../../../components/form/FormButton'
import { DialogContext } from '../../../../components/layout/dialog'
import { ActionPanelContext, DetailsPanelContext } from '../../../../components/layout/rightPanels'
import { useSnackbar } from '../../../../components/layout/snackbar/SnackbarContext'
import { parseHTMLWithBold } from '../../../../utils/boldUtils'
import { colors, TYPE_DIALOG } from '../../../../utils/constants'
import { LocalDateTime } from '../../../../utils/date/local-date-time'
import { updateTache } from '../../gestionTache/services/api'
import UpdateTaskForm from '../component/panel/UpdateTaskForm'
import { PANEL_FORM } from '../tool/tourPlaine.constants'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'

const popinStyles = {
	titleIcon: {
		color: colors.error,
		marginRight: 8
	},
	container: {
		margin: '12px 24px',
		maxWidth: 600,
		lineHeight: '20px'
	},
	warnings: {
		display: 'block',
		whiteSpace: 'pre-line',
		textAlign: 'justify',
		margin: '0px 12px 12px 12px'
	}
}

/**
 * Inject the actions Form
 */
export const injectTaskUpdateForm = (WrappedComponent) => {

	const TaskUpdateFormInjector = ({
		...props
	}) => {
		const intl = useIntl()
		const { snackError, snackSuccess } = useSnackbar()
		const { openPanel, closePanel } = useContext(ActionPanelContext)
		const { closePanel: closeDetailsPanel } = React.useContext(DetailsPanelContext)
		const { openDialog, closeDialog } = useContext(DialogContext)

		const formActions = [
			<FormButton type="primary" formName={PANEL_FORM.UPDATE_TASK}>
				<FormattedMessage id="tourPlaine.form.submit" />
			</FormButton>
		]

		const submitUpdate = (task, values, onSuccess, forceUpdate) => {
			return updateTache(task.id, {
				...values,
				date: LocalDateTime.toApiDateTime(new Date(values.date)),
				ressources: values.ressources.map(r => r.code),
				forceUpdate
			})
				.then((result) => {
					if (result.hasWarnings) {
						openDialog(
							<Grid container spacing={1}>
								<WarningRoundedIcon style={popinStyles.titleIcon} />
								<FormattedMessage id="tourPlaine.form.updateTask.warnings.title" />
							</Grid>,
							<Grid container style={popinStyles.container}>
								<FormattedMessage id="tourPlaine.form.updateTask.warnings.description" />
								<br />
								<Grid item xs={12} style={popinStyles.warnings}>
									{result.warnings.map((warning) => <>
										{parseHTMLWithBold(`${intl.formatMessage({ id: 'tourPlaine.form.updateTask.warnings.item' }, { warning })}`)}
										<br />
									</>)}
								</Grid>

							</Grid>,
							[
								<Button
									type="primary"
									onClick={() => submitUpdate(task, values, onSuccess, true)}
								>
									<FormattedMessage id="actions.confirm" />
								</Button>
							],
							TYPE_DIALOG.ACTION,
							'actions.cancel',
							undefined,
							true
						)
					} else {
						onSuccess(true)
						snackSuccess({ id: 'snackbar.update.tourPlaine.generic' })
						closePanel()
						closeDetailsPanel()
						closeDialog()
					}
				})
				.catch((e) => {
					snackError({ id: 'snackbar.error.tourPlaine.generic' })
					throw new SubmissionError(e)
				})
		}

		const openTaskUpdateForm = (task, onSuccess) => {
			closePanel()
			openPanel(
				<Grid container alignItems="center" style={{ gap: 20 }}>
					<EditIcon color="primary" />
					<FormattedMessage id="tourPlaine.form.updateTask.title" />
				</Grid>,
				<UpdateTaskForm
					task={task}
					onSuccess={onSuccess}
					onSubmit={values => submitUpdate(task, values, onSuccess, false)}
				/>,
				formActions
			)
		}

		return <WrappedComponent
			{...props}
			openTaskUpdateForm={openTaskUpdateForm}
		/>
	}

	return TaskUpdateFormInjector
}
